import template from './users.html';
import controller from './users.controller';

let usersComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default usersComponent;
